import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import './index.module.less';

import { IToastOptions, IToastProps } from './index.d';

const container = document.getElementById('prompt');

const Toast = (props: IToastOptions) => {
  const { type, title, timer, callback } = props;
  useEffect(() => {
    const milliseconds = timer || 1000;
    setTimeout(() => {
      if (typeof callback === 'function') {
        callback();
      }
      if (container) {
        ReactDOM.unmountComponentAtNode(container);
      }
    }, milliseconds);
  }, [callback, timer]);

  if (type === 'strip') {
    const TitleComponent = Array.isArray(title) ? title.map((text, i) => <p key={i}>{text}</p>) : title;
    return (
      <div className="flex flex-center" styleName="container">
        <div styleName="toast-strip">{TitleComponent}</div>
      </div>
    );
  } else if (type === 'strip-bottom') {
    const TitleComponent = Array.isArray(title) ? title.map((text, i) => <p key={i}>{text}</p>) : title;
    return (
      <div className="flex flex-center" styleName="bottom-container">
        <div styleName="toast-strip">{TitleComponent}</div>
      </div>
    );
  }
  return (
    <div className="inline-flex" styleName="toast">
      <i className="iconfont icon-confirm" />
      <span>{title}</span>
    </div>
  );
};

const ToastProps: IToastProps = {
  show(options) {
    /* eslint-disable no-param-reassign */
    if (typeof options === 'string') {
      options = {
        title: options,
      };
    }
    /* eslint-enable no-param-reassign */
    ReactDOM.render(<Toast {...options} />, container);
  },
};

export default ToastProps;
